/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectBudgetResourceAmounts
 */
export interface ProjectBudgetResourceAmounts {
    /**
     * 
     * @type {number}
     * @memberof ProjectBudgetResourceAmounts
     */
    invoiced: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectBudgetResourceAmounts
     */
    remaining: number;
}

/**
 * Check if a given object implements the ProjectBudgetResourceAmounts interface.
 */
export function instanceOfProjectBudgetResourceAmounts(value: object): value is ProjectBudgetResourceAmounts {
    if (!('invoiced' in value) || value['invoiced'] === undefined) return false;
    if (!('remaining' in value) || value['remaining'] === undefined) return false;
    return true;
}

export function ProjectBudgetResourceAmountsFromJSON(json: any): ProjectBudgetResourceAmounts {
    return ProjectBudgetResourceAmountsFromJSONTyped(json, false);
}

export function ProjectBudgetResourceAmountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectBudgetResourceAmounts {
    if (json == null) {
        return json;
    }
    return {
        
        'invoiced': json['invoiced'],
        'remaining': json['remaining'],
    };
}

export function ProjectBudgetResourceAmountsToJSON(value?: ProjectBudgetResourceAmounts | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'invoiced': value['invoiced'],
        'remaining': value['remaining'],
    };
}

